<template>
    <div class="integrity_list">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="top">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div class="centerTab">
                <div><img src="../../assets/img/index/CXGheader.png" alt="" style="width: 100%;"></div>
                <div class="menuTab">
                    <div class="top">
                        <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="left">
                    <div class="box1">
                        <div class="publicTop">
                            <div class="title">
                                <img src="../../assets/img/index/creditKnowledge.png" alt="">
                                <span style="margin-left: 5px;">信用知识</span>
                            </div>
                            <div class="more">更多</div>
                        </div>
                        <div class="list">
                            <ul>
                                <li v-for="(item, index) in box1List" :key="index">
                                    <div style="display: flex;justify-content: left;align-items: center;height: 46px;line-height: 46px;padding: 0 0 0 15px;">
                                        <img src="../../assets/img/index/arrows6.png" alt="">
                                        <span class="title">{{ item.title }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="box1" style="margin-top: 15px;">
                        <div class="publicTop">
                            <div class="title">
                                <img src="../../assets/img/index/creditManagement.png" alt="">
                                <span style="margin-left: 5px;">信用管理</span>
                            </div>
                            <div class="more">更多</div>
                        </div>
                        <div class="list">
                            <ul>
                                <li v-for="(item, index) in box2List" :key="index">
                                    <div style="display: flex;justify-content: left;align-items: center;height: 46px;line-height: 46px;padding: 0 0 0 15px;">
                                        <img src="../../assets/img/index/arrows6.png" alt="">
                                        <span class="title">{{ item.title }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="title">
                        <div style="width: 6px;height: 20px;border-radius: 6px;background: linear-gradient(to bottom, #1A68E8, #fff);"></div>
                        <div class="text">{{ documentTitle }}</div>
                    </div>
                    <div style="display: flex;align-items: center;background-color: #f5f5f5;margin-top: 10px;width: 55%;">
                        <img src="../../assets/img/index/division3.png" alt="" style="width: 100%;">
                        <img src="../../assets/img/index/division4.png" alt="" style="width: 100%;">
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in contentList" :key="index">
                                <span class="title">{{ item.title }}</span>
                                <div class="look">
                                    <span @click="toDetail(item)">查看</span>
                                </div>
                            </li>
                        </ul>
                        <el-empty class="empty" description="未找到您想要的" v-if="empty"></el-empty>
                        <el-pagination @current-change="currentChange"
                          background
                          :current-page="page"
                          layout="prev, pager, next, jumper"
                          next-text="下一页"
                          prev-text="上一页"
                          :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'integrity_list',
    components: {
        publicHeaders,
        foot,
    },
    data() {
        return {
            documentTitle: '',
            tree: [],
            menuTabList: [
                {
                    name: '首页',
                    title: '企业诚信官',
                    url: '/integrity'
                },
                {
                    name: '培训动态',
                    title: '培训动态',
                    url: '/integrity_list'
                },
                // {
                //     name: '新闻图片',
                //     title: '新闻图片',
                //     url: '/integrity_list'
                // },
                {
                    name: '活动通知',
                    title: '活动通知',
                    url: '/integrity_list'
                },
                {
                    name: '政策文件',
                    title: '政策文件',
                    url: '/integrity_list'
                },
                {
                    name: '优秀学员',
                    title: '优秀学员',
                    url: '/goodStudents'
                },
                {
                    name: '证书查询',
                    title: '证书查询',
                    url: ''
                },
                {
                    name: '师资介绍',
                    title: '师资介绍',
                    url: '/integrity_search'
                },
                {
                    name: '培训课程',
                    title: '培训课程',
                    url: '/integrity_list'
                },
                {
                    name: '推荐图书',
                    title: '推荐图书',
                    url: '/integrity_list'
                },
            ],
            box1List: [
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '从大众到冷门，这些 APP 经历了什么'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
            ],
            box2List: [
                // {
                //     title: '2018年度中国企业信用500强名单2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
                // {
                //     title: '2018年度中国企业信用500强名单'
                // },
            ],
            contentList: [
                // {
                //     title: '青春主场｜欢聚在成都'
                // },
                // {
                //     title: '有人用AI“拍”了一部《芭本海默》，堪比好莱坞原片'
                // },
                // {
                //     title: '长租公寓的风险应留意'
                // },
                // {
                //     title: '有人用AI“拍”了一部《芭本海默》，堪比好莱坞原片'
                // },
                // {
                //     title: '天气炎热食物容易变质，夏季警惕“危险”食物'
                // },
                // {
                //     title: '闽人智慧丨土楼不土，尽显科学与艺术之美'
                // },
                // {
                //     title: '经济学家高善文：25-59岁人口失业率创新低 简单讨论失业率非常不完整经济学家高善文：25-59岁人口失业率创新低 简单讨论失业率非常不完整'
                // },
                // {
                //     title: '智慧农业风起，中科原动力带机器人走进田间地头'
                // },
                // {
                //     title: '中国正能量，为奋进的中国吹响号角'
                // },
            ],
            page: 1,
            total: 0,
            empty: false,
            isSearch: false,
            searchTitle: ''
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        this.searchPlaceholder = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        this.getTree()
    },
    methods: {
        // 获取分类
        getTree() {
            let _this = this
            this.tree = []
            let params = {}
            api.getTree().then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    _this.tree = data.data
                    
                    if (_this.$route.query.searchName != undefined) {
                        _this.searchTitle = _this.$route.query.searchName
                        _this.isSearch = true
                        _this.getList(_this.$route.query.searchName)
                    } else {
                        _this.searchTitle = ''
                        _this.isSearch = false
                        _this.getList()
                    }
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        
        // 获取列表
        getList(searchTitle) {
            let _this = this
            _this.contentList = []
            let params = {
                cateId: '',
                title: '',
                page: _this.page,
                size: 10,
            }
            if (searchTitle != undefined) {
                params.title = searchTitle
            }
            _this.tree.forEach(element => {
                if (element.name == _this.documentTitle) {
                    params.cateId = element.id
                } else {
                    if (element.name == '企业诚信官') {
                        if (element.child != undefined) {
                            element.child.forEach(val => {
                                if (val.name == _this.documentTitle) {
                                    // console.log(val);
                                    params.cateId = val.id
                                }
                            })
                        }
                    }
                }
            });
            api.getList(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.contentList = data.data.data
                    _this.total = data.data.total
                    if (data.data.total == 0) {
                        _this.empty = true
                    } else {
                        _this.empty = false
                    }
                } else {
                    _this.empty = true
                }
            })
            .catch(error => {
                _this.empty = true
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 分页
        currentChange(val) {
            this.page = val;
            this.getList()
        },

        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },

        // 查看详情
        toDetail(item) {
            // let routeUrl = this.$router.resolve({
            //   path: "/integrity_detail"
            // });
            let title = ''
            if (this.documentTitle == '新闻中心') {
                title = '新闻详情'
            } else {
                title = this.documentTitle + '详情'
            }

            this.$router.push({
                name: 'integrity_detail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        }
    }
}
</script>

<style lang="less" scoped>
.integrity_list {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .top {
            flex: 1;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
        }
        .centerTab {
            margin-top: 10px;
            .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 20px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
        }
        .content {
            display: flex;
            justify-content: space-between;
            min-height: 600px;
            margin-top: 10px;
            .left {
                flex: 1;
                .publicTop {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    border: 1px solid #85B2FF;
                    background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                    .title {
                        color: #134AA6;
                        font-size: 20px;
                        display: flex;
                        align-items: center;
                    }
                    .more {
                        color: #666;
                        cursor: pointer;
                    }
                }
                .box1 {
                    width: 357px;
                    .list {
                        border: 1px solid #D9D9D9;
                        border-top: none;
                        .title {
                            margin-left: 10px;  
                            color: #666;
                            font-size: 20px;
                            width: 320px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            cursor: pointer;
                        }
                        .title:hover {
                            color: #258AFF;
                        }
                        li:nth-of-type(n+2) {
                            border-top: 1px solid #D9D9D9;
                        }
                    }
                }
            }
            .right {
                flex: 3;
                border: 1px solid #D9D9D9;
                min-height: 800px;
                padding: 20px 30px;
                margin-left: 10px;
                /* width: 1105px; */
                .title {
                    display: flex;
                    align-items: center;
                    .text {
                        font-size: 22px;
                        color: #333;
                        margin-left: 15px;
                    }
                }
                .list {
                    position: relative;
                    ul {
                        min-height: 640px;
                    }
                    .empty {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                    li {
                        border-bottom: 1px solid #E6E6E6;
                        display: flex;
                        justify-content: space-between;
                        padding: 25px 0 20px;
                        .title {
                            display: inline-block;
                            /* width: 940px; */
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .look {
                            span {
                                border: 1px solid #1A68E8;
                                padding: 5px 10px;
                                color: #1A68E8;
                                cursor: pointer;
                            }
                        }
                    }
                    /deep/ .el-pagination {
                        display: flex;
                        justify-content: center;
                        margin-top: 20px;
                    }
                    /deep/ .el-pager li {
                        background: #fff;
                        border: 1px solid #ddd;
                        border-radius: 1px;
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        width: 34px;
                    }
                    /deep/ .el-pager li:nth-of-type(n+2) {
                        border-left: none;
                    }
                    /deep/ .btn-next {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-left: none;
                    }
                    /deep/ .btn-prev {
                        margin: 0;
                        height: 34px;
                        line-height: 34px;
                        padding: 0 15px;
                        display: flex;
                        align-items: center;
                        background: #fff;
                        border: 1px solid #ddd;
                        border-right: none;
                    }
                    /deep/ .el-pager li:not(.disabled).active {
                        background-color: #1A68E8;
                    }
                }
            }
        }
    }
}
</style>

